import {
  LibraryDocumentInstructionEditRunStatus,
  LibraryDocumentInstructionEditStage,
  LibraryDocumentInstructionEditStartResult,
  LibraryDocumentInstructionEditStatus,
  LibraryDocumentInstructionEditTransitionResult,
} from 'models/copilot/libraryDocumentInstructionEditProcess';
import {
  LibraryDocumentInstructionEditStartResultDTO,
  LibraryDocumentInstructionEditStatusDTO,
  LibraryDocumentInstructionEditTransitionResultDTO,
} from 'models/dto/copilot/libraryDocumentInstructionEditProcessDTO';
import { fromApiDateTimeOptional } from 'utils/datetime';

export function mapFromLibraryDocumentInstructionEditStatus(
  dto: LibraryDocumentInstructionEditStatusDTO,
): LibraryDocumentInstructionEditStatus {
  return {
    exists: dto.exists ?? false,
    externalId: dto.externalId ?? '',
    libraryLinkId: dto.libraryLinkId ?? 0,
    libraryListId: dto.libraryListId ?? 0,
    title: dto.title,
    status: dto.status ?? LibraryDocumentInstructionEditRunStatus.NotStarted,
    stage: dto.stage ?? LibraryDocumentInstructionEditStage.Prepared,
    runId: dto.runId,
    attemptCount: dto.attemptCount ?? 0,
    startedByUserId: dto.startedByUserId,
    lastClaimedByUserId: dto.lastClaimedByUserId,
    workerHeartbeat: fromApiDateTimeOptional(dto.workerHeartbeat),
    heartbeatStale: dto.heartbeatStale ?? false,
    started: fromApiDateTimeOptional(dto.started),
    modified: fromApiDateTimeOptional(dto.modified),
    completed: fromApiDateTimeOptional(dto.completed),
    startedSharePointVersion: dto.startedSharePointVersion,
    startedSharePointModified: fromApiDateTimeOptional(dto.startedSharePointModified),
    savedSharePointVersion: dto.savedSharePointVersion,
    savedSharePointModified: fromApiDateTimeOptional(dto.savedSharePointModified),
  };
}

export function mapFromLibraryDocumentInstructionEditStartResult(
  dto: LibraryDocumentInstructionEditStartResultDTO,
): LibraryDocumentInstructionEditStartResult {
  return {
    started: dto.started ?? false,
    conflict: dto.conflict ?? false,
    status: dto.status ? mapFromLibraryDocumentInstructionEditStatus(dto.status) : undefined,
    runId: dto.runId,
    libraryLinkId: dto.libraryLinkId,
    libraryListId: dto.libraryListId,
    driveItemId: dto.driveItemId,
    title: dto.title,
    pendingInstruction: dto.pendingInstruction,
  };
}

export function mapFromLibraryDocumentInstructionEditTransitionResult(
  dto: LibraryDocumentInstructionEditTransitionResultDTO,
): LibraryDocumentInstructionEditTransitionResult {
  return {
    applied: dto.applied ?? false,
    conflict: dto.conflict ?? false,
    status: dto.status ? mapFromLibraryDocumentInstructionEditStatus(dto.status) : undefined,
  };
}
